// src/AppRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSession } from './contexts/SessionContext';
import AutoSearch from './pages/AutoSearch/AutoSearch';
import PropertySearch from './pages/PropertySearch/PropertySearch';
import LogoutPage from './pages/Logout';
import { PageNotFound } from './pages/PageNotFound';

const AppRoutes: React.FC = () => {
  const { isLoggedOut } = useSession();

  // If session is logged out, show logout page for all routes
  if (isLoggedOut) {
    return (
      <Routes>
        <Route path="*" element={<LogoutPage />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* External User Routes - Primary routes */}
      <Route path="/auto" caseSensitive element={<AutoSearch mode="external" />} />
      <Route path="/property" caseSensitive element={<PropertySearch mode="external" />} />

      {/* Fallback route - show 404 for invalid paths */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;